import React, { createContext, useContext, ReactNode } from 'react';
import useLoadingState from '../hooks/useLoadingState';

interface LoadingContextType {
  startLoading: (key: string) => void;
  stopLoading: (key: string) => void;
  isLoading: (key: string) => boolean;
  resetLoading: () => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

interface LoadingProviderProps {
  children: ReactNode;
}

export const LoadingProvider: React.FC<LoadingProviderProps> = ({ children }) => {
  const { startLoading, stopLoading, isLoading, resetLoading } = useLoadingState();

  return (
    <LoadingContext.Provider value={{ startLoading, stopLoading, isLoading, resetLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};